import { useColorModeValue } from "@chakra-ui/react";

export function useEnvironmentColors() {
  const colors = {
    production: {
      icon: useColorModeValue("blue.500", "blue.400"),
      text: "chakra-body-text",
    },
    nonProduction: {
      icon: useColorModeValue("orange.400", "orange.400"),
      text: "chakra-body-text",
    },
  };
  return colors;
}
